import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push, set, update, onValue, off, get, runTransaction } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDlYjjZw113D1QaaeofPMI-HUqPmnt4YOw",
  authDomain: "dl-track-test.firebaseapp.com",
  projectId: "dl-track-test",
  storageBucket: "dl-track-test.firebasestorage.app",
  messagingSenderId: "821725917588",
  appId: "1:821725917588:web:d6dbfb091f0b8551d0df81"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db, ref, push, set, update, onValue, off, get, runTransaction };

export const logAction = (action, userId, targetId, metadata = null) => {
  const logRef = push(ref(db, 'logs'));
  const logEntry = {
    action,
    user: userId,
    target: targetId,
    timestamp: Date.now()
  };
  if (metadata) {
    logEntry.metadata = metadata;
  }
  set(logRef, logEntry);
};
